import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppCoreService } from 'src/app/services/app-core.service';
import { PickupService } from 'src/app/services/operations/pickup.service';
import { UserManagementService } from 'src/app/services/user-management.service';
import Swal from "sweetalert2";

@Component({
    selector: 'app-transfer-pickups',
    templateUrl: './transfer.component.html',
    styleUrls: ['./transfer.component.scss']
})

export class TransferPickupsComponent implements OnInit {
    transferPickupsForm: FormGroup;
    isFormSubmitted = false;
    fieldExecutiveList: any[];
    
    constructor(
        private appCoreService: AppCoreService,
        public activeModal: NgbActiveModal,
        private ngxLoaderService: NgxUiLoaderService,
        private _fb: FormBuilder,
        private userManagmentService: UserManagementService,
        private pickupService: PickupService,
        private titleService: Title
    ) {
        titleService.setTitle('Pickup');
     }

    ngOnInit() {
        this.transferPickupsForm = this._fb.group({
            txtDate: [this.formateDate().dateString, Validators.compose([Validators.required])],
            ddlFrom: [null, Validators.compose([Validators.required])],
            ddlTo: [null, Validators.compose([Validators.required])],
        });

        this.appCoreService.SelectedServiceCenter().subscribe(sc=>{
            this.bindFieldExecutive(sc);
        })
    }

    bindFieldExecutive(sc) {
        try {
            this.userManagmentService.GetUserByGroup('fe', sc).subscribe((res) => {
                if (res && res.success) {
                    const data = res.data;
                    this.fieldExecutiveList = data;
                }
            })
        } catch (err) {
            console.error(err);
        }
    }

    onSaveClick() {
        try {
            this.isFormSubmitted = true;
            if (this.transferPickupsForm.valid) {
                const reqObj = {
                    date: this.transferPickupsForm.get('txtDate')?.value,
                    from: this.transferPickupsForm.get('ddlFrom')?.value,
                    to: this.transferPickupsForm.get('ddlTo')?.value,
                }
                if (reqObj.from == reqObj.to) {
                    this.warningDialog(' "From" and "To"  field executive should not have same value');
                    return;
                }
                this.ngxLoaderService.start();
                this.pickupService.TransferPickups(reqObj).subscribe((res) => {
                    if (res && res.success) {
                        this.ngxLoaderService.stop();
                        this.activeModal.close();
                        this.appCoreService.showMessage('Pickup transferred successfully', 'Success', 'success');
                    }
                    if (res && !res.success) {
                        this.activeModal.dismiss('Pickup transferred failed');
                        this.ngxLoaderService.stop();
                        this.appCoreService.showMessage(res.message, 'Warning', 'warning');
                    }
                });
            }
        } catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
        }
    }

    formateDate(date?: any) {
        const inputDate = date != null || undefined ? new Date(date) : new Date();
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, '0');
        const day = inputDate.getDate().toString().padStart(2, '0');
        const hh = inputDate.getHours() < 10 ? ('0' + inputDate.getHours()) : inputDate.getHours();
        const mm = inputDate.getMinutes() < 10 ? ('0' + inputDate.getMinutes()) : inputDate.getMinutes();
        const dateTimeString = `${year}-${month}-${day}T${hh}:${mm}`;
        const dateString = `${year}-${month}-${day}`;
        return { dateString, dateTimeString };
    }

    async warningDialog(msg: any) {
        await Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'OK',
            allowEscapeKey: false,
            allowOutsideClick: false
        });
    }
}